import React from "react";
import styled from "styled-components";

export default function ProvisionTitleInput(props) {
  const {
    value, 
    setValue, 
    placeholder
  } = props;

	function handleChange(e) {
    setValue(e.target.value);
	}

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={handleChange}/>
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0;

  width: calc(100% - 2px);
  height: calc(100% - 2px);

  border: 1px solid ${props => props.theme.line};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

  padding: 0;

  width: calc(100% - 20px);
  height: 100%;

	outline: none;
  border: 0px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	::placeholder {
    color: ${props => props.theme.line};
	}
	
  transition: all 0.3s ease-in-out;
`;